import { TResult, makeFailure, makeSuccess } from "../../sg-core";
import { default as JSCookies } from "js-cookie";



export const getCookie = (key: string) => {
    const rawData = JSCookies.get(key);

    if (rawData) {
        try {
            const data = JSON.parse(rawData)
            if (data === "undefined") throw Error("ERR_NOT_IN_STORAGE")
            return makeSuccess<any>(data);
        } catch (jsonParseError) {
            JSCookies.remove(key)
            return makeFailure(jsonParseError as Error);
        }
    }
    return makeFailure(new Error("ERR_NOT_IN_STORAGE"));
};

export const setCookie = (key: string, value: any, attributes?: any) => JSCookies.set(key, JSON.stringify(value), attributes);
export const removeCookie = (key: string) => JSCookies.remove(key);



export interface IAppStorage<T extends string | object> {
    get: () => TResult<T>;
    set: (value: T) => void;
    delete: () => void;
}

export const useCookie = <T extends string | object>(key: string, attributes: Cookies.CookieAttributes): IAppStorage<T> => {
    return {
        get: () => getCookie(key),
        set: (value: T) => setCookie(key, value, attributes),
        delete: () => removeCookie(key),
    };
};
